import { connect } from 'react-redux';
import withPGTranslation from '@app/config/withPGTranslation';
import { QuickTopupBanner } from './quick_topup_banner';

const mapStateToProps = ({ topup, chat: { state, advisorId }, user: { user } }: { topup: object, chat: { state: string, advisorId?: number }, user: { user?: { currency?: string } } | null; }) => ({
  ...topup,
  chatState: state,
  advisorId,
  currency: user?.currency
});

export default connect(mapStateToProps)(withPGTranslation(QuickTopupBanner));
